import { api } from './api';

// Аналитика и массовые уведомления — используем Notifications + существующие сущности.
// Здесь предполагаем отдельные админские эндпоинты, которые вы можете реализовать на бэкенде.

export const analyticsService = {
  // Ожидаемый ответ: объект с агрегированными метриками
  getSummary: async () => {
    const { data } = await api.get('/admin/analytics/summary');
    return data;
  },

  // Массовые уведомления пользователям
  sendBroadcastNotification: async (payload) => {
    // payload: { message, segment, image?, data? }
    const { data } = await api.post('/admin/notifications/broadcast', payload);
    return data;
  },
};

